<template>
  <v-dialog
    overlay-color="rgba(0,0,0,0.4)"
    overlay-opacity="0.8"
    v-model="state"
    max-width="420"
    scrollable
    persistent
  >
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(editDriver)" class="px-3">
        <v-card flat ref="form">
          <v-card-title>
            <span class="font-weight-bold blue-grey--text ml-1"
              >Edit Driver</span
            >
            <v-spacer></v-spacer>
            <v-btn icon @click="close" color="prmary">
              <i class="material-icons">close</i>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-col>
              <v-row>
                <ValidationProvider
                  tag="div"
                  class="d-flex flex-row flex-grow-1"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <v-text-field
                    outlined
                    autofocus
                    v-model="driver.name"
                    class="ft font-weight-medium font-size-md"
                    label="Driver's Full Name"
                    :error-messages="errors[0]"
                    hint="Name of the driver"
                  />
                </ValidationProvider>
              </v-row>
              <v-row>
                <ValidationProvider
                  tag="div"
                  class="d-flex flex-row flex-grow-1"
                  v-slot="{ errors }"
                  rules="required|numeric"
                >
                  <v-text-field
                    outlined
                    v-model="driver.phoneNumber"
                    class="ft font-weight-medium font-size-md"
                    label="Contact Number"
                    :error-messages="errors[0]"
                    hint="Contact of driver"
                  />
                </ValidationProvider>
              </v-row>
              <v-row v-if="!driver.driverAssignCarId">
                <ValidationProvider
                  tag="div"
                  class="d-flex flex-row flex-grow-1"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <v-autocomplete
                    outlined
                    class="ft font-weight-medium"
                    label="Assign Car To This Driver"
                    :error-messages="errors[0]"
                    :items="cars"
                    v-model="driver.carId"
                    item-value="id"
                    item-text="registrationNumber"
                  >
                    <template #item="{item}">
                      <div class="d-flex flex-row flex-grow-1">
                        <div class="d-flex flex-row">
                          <v-avatar
                            size="40"
                            class="white--text"
                            color="primary"
                            >{{ item.registrationNumber.charAt(0) }}</v-avatar
                          >
                        </div>
                        <div class="d-flex flex-row flex-grow-1 mt-2 ml-3">
                          <v-chip label small>
                            <span
                              class="ft font-weight-bold text-uppercase text-lg"
                              >{{ item.registrationNumber }}</span
                            >
                          </v-chip>
                          <v-chip
                            v-if="item.model || item.brand"
                            label
                            small
                            class="ml-2"
                          >
                            <span
                              class="ft font-weight-bold text-uppercase text-lg"
                              >{{ item.model ? item.model : item.brand }}</span
                            >
                          </v-chip>
                        </div>
                      </div>
                    </template>
                    <template #no-data>
                      <div class="d-flex flex-row flex-grow-1 justify-center">
                        <span
                          class="ft mx-2 font-size-md font-weight-medium pa-2"
                          >No Vehicle Added Yet</span
                        ><v-btn
                          @click.stop="open('newCar')"
                          text
                          color="primary"
                        >
                          <span class="font-size-sm ft text-capitalize"
                            >Add New Vehicle</span
                          >
                          <i class="material-icons">add</i>
                        </v-btn>
                      </div>
                    </template>
                  </v-autocomplete>
                </ValidationProvider>
              </v-row>
              <p
                v-if="!driver.driverAssignCarId"
                class="red--text text-italic ft font-weight-medium font-size-sm"
              >
                To reassign a driver to a truck, you'll have to unassign one.
              </p>
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn class="mr-2 ft text-capitalize" text @click="close">
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              :loading="loading"
              :disabled="loading"
              type="submit"
              class="ft white--text text-capitalize"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { numeric, required } from "vee-validate/dist/rules";
import { mapGetters } from "vuex";

extend("required", {
  ...required,
  message: "Field is required"
});
extend("numeric", {
  ...numeric,
  message: "Field accept only numbers"
});
export default {
  name: "AddDriverAndAssignCar",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    ValidationProvider,
    ValidationObserver
  },
  props: {
    cars: {
      type: Array,
      default: () => []
    },
    state: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    progress: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialogState: {
      newCar: false
    },
    driver: {
      id: null,
      name: "",
      phoneNumber: "",
      carId: null,
      driverAssignCarId: null
    }
  }),
  computed: {
    ...mapGetters({
      details: "transport/getDriverDetails"
    })
  },
  watch: {
    details(payload) {
      const { id, name, phoneNumber, driverAssignCarId } = payload;
      this.driver = {
        id,
        name,
        phoneNumber,
        carId: driverAssignCarId ? driverAssignCarId?.carId?.id : null,
        driverAssignCarId: driverAssignCarId ? driverAssignCarId?.id : null
      };
    }
  },
  methods: {
    editDriver() {
      this.$emit("editDriver", this.driver);
    },
    close() {
      this.$emit("actions", "edit");
    }
  }
};
</script>
